import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { ForgotPasswordForm } from '.';

const blockName = 'forgot-password-section';

export interface IForgotPasswordSectionProps {
  buttonsPortal?: () => HTMLElement;
  onSuccess?: () => void;
}

export default function ForgotPasswordSection({ buttonsPortal, onSuccess }: IForgotPasswordSectionProps) {
  const bem = bemBlock(blockName);

  return (
    <section className={bem()}>
      <ForgotPasswordForm buttonsPortal={buttonsPortal} onSuccess={onSuccess} />
    </section>
  );
}
